import React from 'react';
import clsx from 'clsx';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { Card } from '@tribeplatform/react-ui-kit/Card';
export const AnnouncementBlock = ({ title, description, actionText, actionUrl, align, viewStyle, hidden, }) => {
    if (hidden) {
        return null;
    }
    const cardStyle = [
        viewStyle === 'vibrant' && 'bg-action-primary text-content-on-primary',
    ];
    const buttonVariant = viewStyle === 'vibrant' ? 'outline' : 'primary';
    return (React.createElement(Card, { className: clsx('overflow-hidden', cardStyle) },
        React.createElement(Card.Content, { className: clsx(align === 'center' && 'text-center') },
            title ? (React.createElement(Card.Header, null,
                React.createElement("h2", null, title))) : null,
            description ? React.createElement(Card.Content, null, description) : null,
            actionText && actionUrl ? (React.createElement(Card.Footer, null,
                React.createElement(Button, { size: "lg", as: "a", href: actionUrl, variant: buttonVariant }, actionText))) : null)));
};
//# sourceMappingURL=Block.js.map